export default function PHP_popen() {
  return (
    <div>
      <h1>PHP_popen</h1>
    </div>
  );
}
